import { AuthorFields, Document, FullAuthored } from 'model';
import { ProfilePic } from './ProfilePic';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './AuthorHeaderEventItem.module.css';

export const AuthorHeaderEventItem = <T extends Document & AuthorFields>({
	authoredItem
}: {
	authoredItem: FullAuthored<T>;
}): ReturnType<React.FC<{ author: FullAuthored<T> }>> => {
	return (
		<div className={styles.authorHeaderContainer}>
			<ProfilePic user={authoredItem.fullAuthor} size={'tiny'} />
			<div className={styles.headerContainer}>
				<div className={styles.userNameSmall}>
					{authoredItem && authoredItem.author && authoredItem.fullAuthor.username}
				</div>
			</div>
		</div>
	);
};
